import React from 'react';
import PropTypes from 'prop-types';
import {
  getIdNode,
  getOnlineStatusIcon,
  downloadStatusToIconSrc,
  getHealthcheckReportIcon,
  getDownloadStatusText,
} from './DeviceUtils';
import ToolTip from '../ToolTipIcon/ToolTip';
import { classNames } from '../../utils/v4/utils';

function DeviceTitle({ auth, device, users }) {
  return (
    <h2 data-test="device-title" className="device-title poppins-bold text-dark-night">
      {device.description}
      <br />
      <div className="flex items-center gap-2">
        {getIdNode(device, users)}
        <span className="flex items-center ">
          {getHealthcheckReportIcon(device, auth)}
          {getOnlineStatusIcon(device)}
          <ToolTip toolText={getDownloadStatusText(device)}>
            <img
              data-test="icon-download-status"
              src={downloadStatusToIconSrc(device)}
              alt="downloading status"
              className={classNames(
                'w-[30px] h-[30px] inline-block m-[5px]',
                device.download_status === 'downloading' ? 'animate-pulse' : '',
                device.idle ? '' : 'opacity-20',
                device.download_status,
              )}
            />
          </ToolTip>
        </span>
      </div>
    </h2>
  );
}

DeviceTitle.propTypes = {
  auth: PropTypes.object,
  device: PropTypes.object.isRequired,
  users: PropTypes.array.isRequired,
};

export default DeviceTitle;
